import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiClient } from 'Utils/api';
import { useTranslation } from 'react-i18next';
import Header from 'View/Component/Header/Header';
import Footer from 'View/Component/Footer/Footer';

const ShortLinkRedirectPage: React.FC = () => {
  const { t } = useTranslation();
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiClient.get(`/api/s/${encodeURIComponent((code || '').toUpperCase())}`);
        if (cancelled) return;
        if (res.data?.status === 'success' && res.data.slug) {
          navigate(`/kaufen/${res.data.slug}`, { replace: true });
        } else {
          setError(res.data?.message || t('shortlink.not_found'));
        }
      } catch (e: any) {
        if (cancelled) return;
        setError(e.response?.data?.message || t('shortlink.not_found'));
      }
    })();
    return () => { cancelled = true; };
  }, [code, navigate, t]);

  return (
    <>
      <Header />
      <main style={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4rem 1.5rem' }}>
        <div style={{ textAlign: 'center', fontFamily: 'Abel', color: '#657455' }} data-testid="shortlink-redirect">
          {error ? error : t('shortlink.redirecting')}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ShortLinkRedirectPage;
